import React, { useState } from 'react';
import { formatEventData, getEventIcon, getEventTitle } from '../utils/eventFormatters';

function SwipeableEventItem({ 
  event, 
  onEdit, 
  onDelete, 
  showTime = true,
  timeFormatter 
}) {
  const [swipeState, setSwipeState] = useState({ translateX: 0, isSwiping: false });

  const handleTouchStart = (e) => {
    const touch = e.touches[0];
    setSwipeState({
      startX: touch.clientX,
      startY: touch.clientY,
      currentX: touch.clientX,
      isSwiping: false,
      isScrolling: false,
      translateX: 0,
      startTime: Date.now()
    });
  };

  const handleTouchMove = (e) => {
    const touch = e.touches[0];
    
    if (!swipeState.startX) return;

    const deltaX = touch.clientX - swipeState.startX;
    const deltaY = touch.clientY - swipeState.startY;
    const absDeltaX = Math.abs(deltaX);
    const absDeltaY = Math.abs(deltaY);

    // Détecter le type de mouvement
    if (absDeltaX > 15 || absDeltaY > 15) {
      if (absDeltaY > absDeltaX && absDeltaY > 10) {
        // Mouvement vertical dominant → scroll
        setSwipeState(prev => ({
          ...prev,
          isScrolling: true
        }));
        return; // Laisser le scroll natif se faire
      } else if (absDeltaX > absDeltaY && absDeltaX > 15) {
        // Mouvement horizontal dominant → swipe
        e.preventDefault(); // Empêcher le scroll pendant le swipe
        setSwipeState(prev => ({
          ...prev,
          isSwiping: true,
          currentX: touch.clientX,
          translateX: deltaX < 0 ? Math.max(deltaX, -100) : 0 // Limiter à -100px
        }));
      }
    }
  };

  const handleTouchEnd = () => {
    const touchDuration = Date.now() - (swipeState.startTime || 0);
    
    if (swipeState.isSwiping && swipeState.translateX < -70) {
      // Swipe assez long → supprimer
      onDelete(event.id);
    } else if (!swipeState.isSwiping && !swipeState.isScrolling && touchDuration < 300) {
      // Tap court sans mouvement → éditer
      onEdit(event);
    }
    // Si isScrolling = true ou touchDuration > 300ms → ne rien faire

    // Reset du swipe
    setSwipeState({ translateX: 0, isSwiping: false, isScrolling: false });
  };

  const formatTime = (dateString) => {
    if (timeFormatter) {
      return timeFormatter(dateString);
    }
    // Format par défaut (Dashboard)
    return new Date(dateString).toLocaleTimeString('fr-FR', {
      hour: '2-digit',
      minute: '2-digit'
    });
  };

  return (
    <div
      className="relative overflow-hidden"
      onTouchStart={handleTouchStart}
      onTouchMove={handleTouchMove}
      onTouchEnd={handleTouchEnd}
    >
      {/* Bouton de suppression en arrière-plan */}
      <div className="absolute right-0 top-0 h-full w-24 bg-red-500 flex items-center justify-center">
        <span className="text-white text-sm font-medium">Supprimer</span>
      </div>
      
      {/* Contenu principal */}
      <div
        className="p-4 flex items-center bg-white transition-transform duration-200 cursor-pointer active:bg-gray-50"
        style={{
          transform: `translateX(${swipeState.translateX}px)`
        }}
        onClick={() => onEdit(event)}
      >
        <div className="text-2xl mr-3">
          {getEventIcon(event.type)}
        </div>
        <div className="flex-1">
          <div className="font-medium text-gray-900">
            {getEventTitle(event.type)}
          </div>
          <div className="text-sm text-gray-600">
            {formatEventData(event)}
          </div>
        </div>
        {showTime && (
          <div className="text-sm text-gray-500">
            {formatTime(event.created_at)}
          </div>
        )}
      </div>
    </div>
  );
}

export default SwipeableEventItem;